import React, { useCallback } from 'react';
import DataTable from '../../components/elements/DataTable';
import Button from '../../components/elements/Button';
import styles from './styles.scoped.css';
import { Switch } from '@mantine/core';
import IconPencil from '../../components/icons/IconPencil';
import PropTypes from 'prop-types';
import IconDownload from '../../components/icons/IconDownload';

const TableReasonBlock = ({
  dataRow,
  handleEdit,
  type,
  handleSwitchStatus,
  handleDownloadFile
}) => {
  const Actions = useCallback(
    ({ data }) => {
      return (
        <div className={styles.actions}>
          <Button
            className={styles.btnDetail}
            // disabled={type === 'reason' ? data.isActive : false}
            onClick={() => handleEdit(data)}
          >
            <IconPencil style={{ fill: 'white' }} />
          </Button>
        </div>
      );
    },
    [styles]
  );

  const renderStatus = (data) => {
    return (
      <Switch checked={data.isActive}
        onChange={(e) => handleSwitchStatus(type,
          { ...data, value: e.target.checked, })} />
    );
  };
  const renderButtonDownload = (data) => {
    return (
      <Button
        className={styles.btnDetail}
        // disabled={type === 'reason' ? data.isActive : false}
        onClick={() => handleDownloadFile(data)}
      >
        <IconDownload />
      </Button>
    );
  };
  const columns = [
    {
      heading: 'Alasan Blokir NIK Pelanggan', value: 'message', className: ''
    },
    {
      heading: 'Status', value: renderStatus, className: ''
    },
    {
      heading: 'Ubah',
      value: (val) => <Actions data={val} />,
      className: '',
    },
  ];
  if (type === 'reason') {
    columns.push({
      heading: 'Unduh',
      value: renderButtonDownload,
      className: ''
    });
  }
  return (
    <>
      <DataTable
        column={columns}
        data={dataRow}
        withIndex
      />
    </>
  );
};

export default TableReasonBlock;

TableReasonBlock.propTypes = {
  dataRow: PropTypes.array,
  handleDownloadFile: PropTypes.func,
  handleEdit: PropTypes.func,
  handleSwitchStatus: PropTypes.func,
  type: PropTypes.string,
};
